export const HEADER_BLOCK_S20 = {
  "temp":{
    "templateId":20
  },
  "blockType": "HEADER",
  "blockDesign": "HeaderDesign2",
  "editFormName": "HEADER_04_FORM",
  "styleProps": {
    "background-image": "url('')",
    "background-color": "#ffffff",
    "padding": "120px 20px 120px 20px"
  },
  "textBlock": {
    "styleProps": {
      "background-color": "",
      "border-radius": "0",
      "padding": "10px 10px 10px 10px"
    },
    "stylePropsTab": {},
    "stylePropsMob": {},
    "alingBlock": "start",
    "headings": [
      {
        "text": "TRANSFORMING BUSINESSES WITH INNOVATIVE SOFTWARE SOLUTIONS",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "1px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "3.75rem",
          "line-height": "1",
          "font-family": "",
          "font-weight": "400",
          "font-family-cust": "",
          "font-family-bk": "'Lato', sans-serif"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "10px 20px 10px 20px",
          "margin": "10px 0px 40px 0px"
        },
        "stylePropsMob": {
          "font-size": "3rem",
          "line-height": "1"
        },
        "stylePropsTab": {
          "font-size": "3.75rem",
          "line-height": "1"
        }
      }
    ],
    "dynamicText": {
      "styleProps": {
        "color": "#ffffff",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "strings": []
    },
    "descriptionsStyleProps": {
      "padding": "10px 0px 10px 0px",
      "text-align": "center",
      "margin": "0px 0px 0px 0px"
    },
    "descriptionsStylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptionsStylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptions": [],
    "buttonsStyleProps": {
      "margin": "50px 0px 0px 0px",
      "padding": "0px 0px 0px 0px"
    },
    "buttonAlign": "start",
    "buttons": [],
    "emailSecStyleProps": {},
    "subscription": {
      "showSection": "hide",
      "display": "enable",
      "subConfigs": {
        "configType": "convertkit",
        "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
        "configPlaceholder": ""
      },
      "email_placeholder": {
        "text": "example@mail.com"
      },
      "buttonText": {
        "text": "Subscribe",
        "styleProps": {
          "background-color": "#1b1b31",
          "color": "#ffffff"
        }
      },
      "successMessage": {
        "text": "Thank you for the signup",
        "styleProps": {}
      },
      "errorMessage": {
        "text": "Something went wrong. Please try again.",
        "styleProps": {}
      }
    },
    "buttonsStylePropsTab": {
      "padding": "0px 0px 0px 0px"
    }
  },
  "imageType": "image",
  "imageVideoPostion": "right",
  "imageBlock": {
    "image": "https://images.pexels.com/photos/3761509/pexels-photo-3761509.jpeg?auto=compress&cs=tinysrgb&w=600",
    "styleProps": {
      "margin": "20px 20px 20px 20px",
      "border-radius": "0px"
    },
    "outerStyleProps": {
      "border-radius": "0px"
    },
    "tagStyleProps": {
      "border-radius": "0px"
    }
  },
  "videoBlock": {
    "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
    "styleProps": {
      "margin": "20px 20px 20px 20px"
    },
    "videoHeight": {
      "height": "400px"
    }
  },
  "htmlBlock": {
    "value": "",
    "styleProps": {}
  },
  "metaDataId": 1746167637606,
  "blockId": 1746167637606,
  "buttons": [
    {
      "text": "Click Here",
      "styleProps": {
        "color": "#ffffff",
        "border-color": "#3b82f680"
      },
      "href": "#",
      "openType": "sametab"
    }
  ],
  "fonts": {
    "textBlock": ""
  },
  "position": "hide",
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "containerStyleProps": {
    "background-color": "",
    "border-radius": "1rem",
    "padding": "0px 0px 0px 0px"
  }
}